import React from "react";
import { Button, Grid, GridColumn, Typography } from "@sumprio/ui";
import { AddIcon, ExportIcon } from "@sumprio/ui/icons";

export interface ListPageHeaderProps {
  title: string;
  addButtonLabel?: string;
  hasItems?: boolean;
  onAdd?: () => void;
  canCreate?: boolean;
  secondaryButtonLabel?: string;
  onSecondary?: () => void;
  showAddWhenEmpty?: boolean;
}

export default function ListPageHeader({
  title,
  addButtonLabel,
  hasItems,
  onAdd,
  canCreate = true,
  secondaryButtonLabel,
  onSecondary,
  showAddWhenEmpty = false,
}: ListPageHeaderProps) {
  const showAddButtonArea = hasItems || showAddWhenEmpty;
  const showAddButton = showAddButtonArea && addButtonLabel;
  const showSecondaryButton = Boolean(secondaryButtonLabel && onSecondary);
  const showAnyButton = showAddButton || showSecondaryButton;

  return (
    <Grid display="flex" justifyContent="space-between" alignItems="center" gap="lg">
      <GridColumn span={2}>
        <Typography variant="heading" headingSize="xs" headingWeight="medium">
          {title}
        </Typography>
      </GridColumn>
      {showAnyButton && (
        <GridColumn span={10} display="flex" justifyContent="flex-end" gap="sm">
          {showSecondaryButton && (
            <Button
              size="sm"
              variant="brand-secondaryColor"
              onClick={onSecondary}
              icon={ExportIcon}
            >
              {secondaryButtonLabel}
            </Button>
          )}
          {showAddButton && canCreate && (
            <Button size="sm" type="brand" variant="primary" icon={AddIcon} onClick={onAdd}>
              {addButtonLabel}
            </Button>
          )}
        </GridColumn>
      )}
    </Grid>
  );
}
